import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSearchSorting = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 8" {...props}>
    <path d="M0 0h5v2H0zm0 3h8v2H0zm0 3h11v2H0z" fillRule="evenodd" />
  </svg>
);
const Memo = memo(SvgSearchSorting);
export default Memo;
